import Vue from 'vue'
import Vuex from 'vuex' 
Vue.use(Vuex)
export default new Vuex.Store ({
  state: {
    
  },  
  mutations: {
   
  }, 
  actions: {
    
   
    // 获取公告
    // getNoticeList({ commit, state },pageSize) {   
    //   console.log(pageSize)   
    //   var data = {
    //       COID : Cookies.get('qslCOID'),          
    //       memberId: Cookies.get('qslmemberId'),
    //       pageIndex:1,
    //       pageSize:pageSize			  
    //   }      
    //   return new Promise((resolve, reject) => {
    //     getAllNotice(data).then(res => {            
    //       resolve(res)              
    //     }).catch(error => {
    //       console.log(error)
    //       reject(error)
    //     })
    //   })
    // },
   
    
  }
})





// WEBPACK FOOTER //
// ./src/store/index.js